export default {"src":"/_next/static/media/info-circle.9cee689d.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};